import { FabbisognoCard } from "@/components/pratica/FabbisogniPanel";

export const FabbisogniCardList = ({ lst, onChange }) => lst.length === 0
  ? <p className="text-xs text-slate-500" data-testid="fabbisogni-box-vuoto">Nessun fabbisogno aperto.</p>
  : <div className="space-y-2">{lst.map((f) => <FabbisognoCard key={f.id} f={f} canEdit compatto onChange={onChange} />)}</div>;
